import { FC, useLayoutEffect, useRef, useState } from "react";
import { ZTooltip } from "../../ZTooltip/ZTooltip";

interface ZFileNameProps {
  filename: string;
  className?: string;
}

const ZFileName: FC<ZFileNameProps> = ({ filename, className }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    if (textRef.current) {
      const { clientHeight, scrollHeight } = textRef.current;
      setIsTruncated(scrollHeight > clientHeight);
    }
  }, [filename, textRef.current]);

  const fileNameParts = filename.split(".");
  const fileExtension = fileNameParts.length > 1 ? fileNameParts.pop() : "";
  const fileNameWithoutExtension = fileNameParts.join(".");

  const handleCopyFileName = (e: any) => {
    e.preventDefault();
    e.clipboardData.setData("text/plain", filename);
  }

  return (
    <ZTooltip showArrow content={<div className="max-w-[30rem] break-words">{filename}</div>} isDisabled={!isTruncated}
    >
      <div className={`flex ${className}`} data-fullname={filename} onCopy={handleCopyFileName}>

        <div ref={textRef} className="truncate-one-line break-all">
          {fileNameWithoutExtension}
        </div>
        {fileExtension && <span>.{fileExtension}</span>}
      </div>
    </ZTooltip>
  );
};

export default ZFileName;
